import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { Button } from "@/components/ui";

export function CopyButton({
  value,
  label = "Copy",
}: {
  value: string;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Some browsers reject writeText outside a secure context. Stay silent
      // — the URL stays visible in the panel for manual copy.
    }
  }

  return (
    <Button variant="ghost" icon={copied ? Check : Copy} onClick={copy}>
      {copied ? "Copied!" : label}
    </Button>
  );
}
